import { useParams } from 'react-router-dom'
import { PublicLayout } from '../../components/Layout/PublicLayout'

import { VerifyEmail } from '../../auth/EmailVerification'

export function VerifyEmailRoute() {
  const { verificationCode = '' } = useParams()
  return (
    <PublicLayout section="verifyEmail">
      <VerifyEmail verificationCode={verificationCode} />
    </PublicLayout>
  )
}
